export const menuItemsData = [
    {
        title: 'Home',
        link: '/'
    },
    {
        title: 'Partner',
        submenu: [
            {
                title: 'Amazon ATES Partner',
                link: "/partner/amazon-ates-partner",
            },
            {
                title: 'Amazon Global Partner',
                link: "/partner/amazon-affiliate-global-partner"
            },
            {
                title: 'Flipkart SPN Partner',
                link: '/partner/flipkart-spn-partner',
            },
            {
                title: 'Jiomart Partner',
                link: '/partner/jiomart-partner'
            },
            {
                title: 'Meesho Partner',
                link: '/partner/meesho-partner'
            },
        ],
    },
    {
        title: 'Our Services',
        submenu: [
            {
                title: ' Domestic Services',
                submenu: [
                    {
                        title: 'Amazon Account Management',
                        link: "/domestic-services/amazon-account-management"
                    },
                    {
                        title: 'Flipkart Account Management',
                        link: "/domestic-services/flipkart-account-management"
                    },
                    {
                        title: 'Meesho Account Management',
                        link: "/domestic-services/meesho-account-management"
                    },
                    {
                        title: 'Jiomart Account Management',
                        link: "/domestic-services/jiomart-account"
                    },
                    {
                        title: 'Purple Account Management',
                        link: "/domestic-services/purple-account"
                    },
                    {
                        title: 'Glow Road Account Management',
                        link: "/domestic-services/glow-road"
                    },
                    // {
                    //     title: 'Lime Road Account Management',
                    //     link: "/domestic-services/lime-road"
                    // },
                ],
            },
            {
                title: ' International Services',
                submenu: [
                    {
                        title: 'Amazon Global Account Management',
                        link: "/international-services/amazon-global"
                    },
                    {
                        title: 'Ebay Account Management',
                        link: "/international-services/ebay"
                    },
                    {
                        title: 'Etsy Account Management',
                        link: "/international-services/etsy"
                    },
                    {
                        title: 'Walmart Account Management',
                        link: "/international-services/walmart"
                    },
                    {
                        title: 'Alibaba Account Management',
                        link: "/international-services/alibaba"
                    },
                ]
            },
 {
                title: ' FBA Services',
                submenu: [
                    {
                        title: 'FBA Shipment & Operations Support',
                        link: "/fba-services/fba-shipment"
                    },
                ]
            },

            {
                title: '  Listing/Cataloging',
                submenu: [
                    {
                        title: 'Amazon Listing Services',
                        link: "/listing-services/amazon"
                    },
                    {
                        title: 'Flipkart Listing Services',
                        link: "/listing-services/flipkart"
                    },
                    {
                        title: 'Meesho Listing Services',
                        link: "/listing-services/meesho"
                    },
                    {
                        title: 'Jiomart Listing Services',
                        link: "/listing-services/jiomart"
                    },
                    {
                        title: 'Etsy Listing Services',
                        link: "/listing-services/etsy"
                    },
                    {
                        title: 'Walmart Listing Services',
                        link: "/listing-services/walmart"
                    },
                    {
                        title: 'Purple Listing Services',
                        link: "/listing-services/purple"
                    },
                    {
                        title: 'Glow Road Listing Services',
                        link: "/listing-services/glow-road"
                    },
                ]
            },
            {
                title: ' Advertisement/Marketing',
                submenu: [
                    {
                        title: 'Amazon Advertisement Services',
                        link: "/advertisement-services/amazon"
                    },
                    {
                        title: 'Flipkart Advertisement Services',
                        link: "/advertisement-services/flipkart"
                    },
                    {
                        title: 'Meesho Advertisement Services',
                        link: "/advertisement-services/meesho"
                    },
                    {
                        title: 'Amazon Global Advertisement Services',
                        link: "/advertisement-services/amazonglobal"
                    },
                    {
                        title: 'Ebay Advertisement Services',
                        link: "/advertisement-services/ebay"
                    },
                ]
            },
            {
                title: ' Sales Boost/Rating & Reviews',
                submenu: [
                    {
                        title: 'Amazon Sales Boost Services',
                        link: "/sales-services/amazon"

                    },
                    {
                        title: 'Flipkart Sales Boost Services ',
                        link: "/sales-services/flipkart"
                    },
                    {
                        title: 'Meesho Sales Boost Services',
                        link: "/sales-services/meesho"
                    },
                    {
                        title: 'Jiomart Sales Boost Services',
                        link: "/sales-services/jiomart"
                    },
                    {
                        title: 'Shopify Sales Boost Services',
                        link: "/sales-services/shopify"
                    },
                    {
                        title: 'Etsy Sales Boost Services',
                        link: "/sales-services/etsy"
                    },
                    {
                        title: 'Walmart Sales Boost Services',
                        link: "/sales-services/walmart"
                    },
                ]
            },
            {
                title: ' Training Ecommerce',
                link: "/services/training"
            },
            {
                title: '  Digital Marketing',
                submenu: [
                    {
                        title: 'SMO Marketing',
                        link: "/marketing-services/smo"
                    },
                    {
                        title: 'SEO',
                        link: "/marketing-services/seo"
                    },
                    {
                        title: 'E-Mail Marketing',
                        link: "/marketing-services/email"
                    },
                    {
                        title: 'SEM Marketing',
                        link: "/marketing-services/sem"
                    },
                    {
                        title: 'SMM Marketing',
                        link: "/marketing-services/smm"
                    },
                    {
                        title: 'Affiliate Marketing',
                        link: "/marketing-services/affliate"
                    },
                ]
            },
            {
                title: 'Product photoshoot/Videography',
                link: "/services/photoshoot"
            },
        ],
    },
    // {
    //     title: 'Calculator',
    //     link: "/calculator"
    // },
    {
        title: 'Free Onboarding',
        submenu: [
            {
                title: 'Amazon Registration',
                link: "/registration-services/amazon"
            },
            {
                title: 'Amazon Global Registration',
                link: "/registration-services/amazon-global"
            },
            {
                title: 'Meesho Registration',
                link: "/registration-services/meesho"
            },
            {
                title: 'Jiomart Registration',
                link: "/registration-services/jiomart"
            },
            {
                title: 'Flipkart Registration',
                link: "/registration-services/flipkart"
            },
            {
                title: 'Glow Road Registration',
                link: "/registration-services/glowroad"
            },
        ],
    },
    {
        title: 'Blog',
        link: '/blog'
    },
    {
        title: 'Contact Us',
        link: '/contact'
    },
    {
        title: 'Career',
        link: '/career'
    },
    {
        title: 'Events',
        link: '/events'
    },
    {
        title: 'About Us',
        link: '/abouts'
    },
];